import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { FittingQueryParams } from '../../../models/fitting-query-params.model';
import { FittingQueryResult } from '../../../models/lookup.model';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { AuthorizationGroups } from 'src/app/util/groups.enum';
import { doctype } from 'src/app/util/doctype.enum';

@Component({
  selector: 'app-filtered-products',
  templateUrl: './filtered-products.component.html',
  styleUrls: ['./filtered-products.component.scss']
})
export class FilteredProductsComponent implements OnInit {
  @Input() results: FittingQueryResult[] = [];
  @Input() active?: number;
  @Input() query?: FittingQueryParams | null;
  @Input() isLoading = false;
  @Input() activeFittingIsConfiguration: boolean = false;
  @Input() activePartNumber?: string;

  @Output() setActiveFitting = new EventEmitter<{ id: number, partNumber: string }>();
  doc: doctype = doctype.fitting;
  isFittingsAdmin$: Observable<boolean> = of(false);

  constructor(private store: Store<fromStore.State>) { }

  ngOnInit(): void {
    this.isFittingsAdmin$ = this.store.select(fromStore.selectors.USERPROFILE.selectHasAllRoles([AuthorizationGroups.FittingsAdmin]));
  }
}
